export interface HeroSlide {
  id: string;
  title: string;
  subtitle: string;
  cta: string;
  link: string;
  image: string;
  badge?: string;
  badgeColor?: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: '1',
    title: 'Mega Tech Sale',
    subtitle: 'Up to 40% off on smartphones, laptops, and electronics. Free delivery in Nairobi.',
    cta: 'Shop Now',
    link: '/shop/electronics',
    image: 'https://readdy.ai/api/search-image?query=Modern%20technology%20showcase%20with%20smartphones%20laptops%20and%20electronics%20arranged%20artistically%20on%20dark%20gradient%20background%2C%20subtle%20red%20and%20gold%20accents%2C%20premium%20product%20photography%2C%20clean%20minimal%20aesthetic%2C%20soft%20lighting%20with%20dramatic%20shadows&width=1600&height=700&seq=hero-tech-01&orientation=landscape',
    badge: 'Limited Time',
    badgeColor: 'primary',
  },
  {
    id: '2',
    title: 'Fashion Week Deals',
    subtitle: 'Discover the latest trends from top brands. Up to 50% off on selected items.',
    cta: 'Explore Fashion',
    link: '/shop/fashion',
    image: 'https://readdy.ai/api/search-image?query=Fashion%20apparel%20display%20with%20trendy%20clothing%20shoes%20and%20accessories%20arranged%20artistically%20on%20warm%20gradient%20background%2C%20gold%20and%20red%20tones%2C%20premium%20editorial%20photography%2C%20clean%20minimal%20aesthetic%2C%20soft%20dramatic%20lighting&width=1600&height=700&seq=hero-fashion-01&orientation=landscape',
    badge: 'Trending',
    badgeColor: 'accent',
  },
  {
    id: '3',
    title: 'Home & Living Essentials',
    subtitle: 'Transform your space with premium furniture, decor, and kitchen appliances.',
    cta: 'Shop Home',
    link: '/shop/home-living',
    image: 'https://readdy.ai/api/search-image?query=Modern%20home%20interior%20showcase%20with%20elegant%20furniture%20decor%20and%20kitchen%20items%20arranged%20artistically%20on%20soft%20warm%20gradient%20background%2C%20premium%20lifestyle%20photography%2C%20clean%20minimal%20aesthetic%2C%20soft%20natural%20lighting%20with%20warm%20tones&width=1600&height=700&seq=hero-home-01&orientation=landscape',
    badge: 'New Collection',
    badgeColor: 'primary',
  },
];

export interface Announcement {
  id: string;
  text: string;
  link: string;
  isNew?: boolean;
}

export const announcements: Announcement[] = [
  {
    id: '1',
    text: 'Free delivery on orders above KSh 5,000 in Nairobi & Mombasa',
    link: '/shipping',
    isNew: true,
  },
  {
    id: '2',
    text: 'New sellers get 0% commission for the first 30 days',
    link: '/become-seller',
  },
  {
    id: '3',
    text: 'Download the KenStore app for exclusive deals',
    link: '/app',
  },
];